module.exports = __webpack_public_path__ + "static/media/copparrot.dfb22527.gif";